(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('invoiceCustomerBonus', {
        templateUrl: 'views/components/views/invoiceCustomerBonus/invoiceCustomerBonus.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$q', 'invoiceCustomerBonusService', 'modalDynamicViewFactory', 'stateService', function ($q, invoiceCustomerBonusService, modalDynamicViewFactory, stateService) {
            var vm = this;
            
            // #region VARIABLES & DEFINITIONS

            vm.gridReady = false;

            vm.icbConfig = {
                isReady: false,
                rememberId: 'w_invoicecustomerbonus.icbconfig',
                data: {
                    stockplace_id: '',
                    from_date: '',
                    to_date: '',
                    cust_grp_id: '',
                    cust_coop_id: '',
                    cust_no: '',
                    prod_grp_id: ''
                }
            };

            vm.grid = {
                dataTask: {
                    rememberId: 'w_invoicecustomerbonus',               // Id used to retrieve user configs for the grid
                    loadData: {                                         // Method id of the get data procedure
                        method: 2329,
                        parameters: vm.icbConfig.data
                    },
                    addRow: {                                           // 
                        method: null,
                        parameters: null
                    },
                    removeRow: {                                        // 
                        method: null,
                        parameters: null
                    },
                    saveData: {
                        method: null,
                        parameters: null
                    }
                },
                translations: [],                                       // Comma separated list of words to be translated
                config: {                                               // TouchTime parameters configuring the grid
                    toolbar: {                                          // alternative -> toolbar: false,
                        hidden: false,                                  // If true, hides the toolbar, default is false
                        pdfExport: true,                                // Adds a predefined btn for exporting grid to pdf
                        excelExport: true,                              // Adds a predefined btn for exporting grid to excel
                        filter: true,                                   // Adds a predefined btn for en-/disabling filtering
                        columnVisibility: true,                         // Adds a predefined btn for deciding which columns to show/hide
                        headers: true,                                  // Adds a predefined btn for switched between db column names and titles
                        edit: false,                                    // Adds a predefined btn for en-/disabling editing in columns
                        lock: false,                                    // NOT IMPLEMENTED
                        add: false,                                     // Adds predefined btns for running an add function     // Needs addRow
                        delete: false,                                  // Adds a predefined btn for running a delete function  // Needs removeRow
                        save: false,                                    // Adds a predefined btn for running a save function    // Needs saveData
                        wrapping: true,                                 // Adds a predefined btn for en-/disabling wrapping of text in columns
                        layouts: true,                                  // Adds a predefined btn for adding, setting or removing predefined column layouts
                        buttons: [                                      // List of custom buttons
                            //{ name: 'ediTranspReturn', text: 'tt_edi_transporter_return', func: function (data) { ediTranspReturn(data); }, icon: 'none', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return hasDirty(); } },
                            //{ name: 'planningReady', text: 'tt_po_sp_planning_ready', func: function (data) { planningReady(data); }, icon: 'none', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return hasDirty(); } },
                            //{ name: 'setProdplace', text: 'tt_po_sp_set_prodplace', func: function (data) { setProdplace(data); }, icon: 'none', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return true; } },
                            { name: 'openConfig', text: 'tt_icb_config', func: function () { callConfigPopup(true); }, icon: 'none', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return false; } },
                            { name: 'printPreview', text: 'tt_print_preview', func: function () { printPreview(); }, icon: 'none', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, disabled: function () { return false; } },
                        ]
                    },
                    fixedHeader: true,                                  // Enables header to stay visible when scrolling
                    keepSortOnAdd: false,                               // Clears sorting when adding a row
                    keepSortOnCheckbox: false,                          // Clears sorting on any clicked checkbox if false
                    keepSortOnIsSelected: false,                        // Clears sorting on only is_selected checkbox if false
                    rowClick: false,                                    // Enables functionality for drilldown on clicked row
                    specialFunc: {                                      // Adds additional functionality to the grid_functions column
                        newTab: false,                                  // If data has path, adds predefined "New tab"-button to functions
                        buttons: [
                            //{ name: 'goToShipment', text: '', func: function (data) { goToShipment(data); }, icon: 'far-truck-container', disabled: function (data) { return goToShipmentDisability(data); } },
                            //{ name: 'goToPoh', text: '', func: function (data) { goToPoh(data); }, icon: 'far-industry', disabled: function (data) { return goToPohDisability(data); } }
                        ]
                    },
                    css: {
                        altColor: true,                                 // accepts -> true, false or hexbased color (i.e: '#A1B2C3')
                        textWrapping: false                             // Enables text-wrapping in columns, default is false
                    },
                    onDataSourceChanges: function (e) {                 // Triggers when changes happen to the dataSource
                        //console.log('onDataSourceChanges');
                        //console.dir(e);
                    }
                },
                kendo: {                                                // Kendo parameters configuring the grid
                    height: null,                                       // Sets the height of the grid component
                    aggregate: true,                                    // accepts -> true, false or list of objects (i.e: [{ field: 'amount_invval', aggregate: 'sum' } ])
                    pager: false,                                       // NOT IMPLEMENTED
                    selectable: false,                                  // accepts -> true, false, 'row', 'multiple' or 'multiple, row'
                    //persistSelection: false,                            // NOT IN USE
                    filterable: false                                   // Adds/Removes filter row, default is set to { mode: "row" }
                },
                optionfunc: function (data) { optionfunc(data.data); }, // Used for referencing functions in the current Component
                gridfunc: null                                          // Used for referencing functions in the Grid Component
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region OPTIONFUNC

            var optionfunc = function (data) {
                //console.log('optionfunc');
                //if (angular.isDefined(data.func) && data.func === 'CellClickHandler') {
                //    console.log('optionfunc - CellClickHandler');
                //    console.dir(data);
                //}

                //if (angular.isDefined(data.func) && data.func === 'OnCellClose') {
                //    console.log('optionfunc - OnCellClose');
                //    console.dir(data);
                //}

                //if (angular.isDefined(data.func) && data.func === 'LookupCellEditor') {
                //    console.log('optionfunc - LookupCellEditor');
                //    console.dir(data);
                //}
            };

            var testfunc = function (data) {
                console.log('testfunc');
                console.dir(data);
            };

            // #endregion OPTIONFUNC

            // #region UTILITY FUNCTIONS

            //var getIsSelectedItemsParm = function (key) {
            //    var dirtyItems = vm.grid.gridfunc.getDirtyRows();
            //    var isSelectedItems = [];

            //    if (angular.isUndefined(key)) key = 'shipmentcontainer_keyno';

            //    angular.forEach(dirtyItems, function (item) {
            //        if (angular.isDefined(item) && item.is_selected === true && angular.isDefined(item[key])) isSelectedItems.push(item[key]);
            //    });

            //    return isSelectedItems;
            //};

            //var hasDirty = function (data) {
            //    var parmItems = getIsSelectedItemsParm();

            //    if (parmItems.length > 0) return false;

            //    return true;
            //};

            //var goTo = function (state, parms) {
            //    if (angular.isUndefined(state) || state === null || state === '') return;
            //    if (angular.isUndefined(parms) || parms === null || parms === '') return;

            //    stateService.go(state, parms);
            //};

            //var getIsSelectedItemsParm = function (key) {
            //    var dirtyItems = vm.grid.gridfunc.getDirtyRows();
            //    var isSelectedItems = [];

            //    if (angular.isUndefined(key)) key = 'shipmentcontainer_keyno';

            //    angular.forEach(dirtyItems, function (item) {
            //        if (angular.isDefined(item) && item.is_selected === true && angular.isDefined(item[key])) isSelectedItems.push(item[key]);
            //    });

            //    return isSelectedItems;
            //};

            var initConfigPopup = function (remValue) {
                var deferred = $q.defer();
                var promises = [];

                promises.push(invoiceCustomerBonusService.getStockplaces({}));
                promises.push(invoiceCustomerBonusService.getCustomerGroups());
                promises.push(invoiceCustomerBonusService.getCoops());
                promises.push(invoiceCustomerBonusService.getProductGroups());

                remValue = angular.isArray(remValue) && angular.isObject(remValue[0]) && angular.isDefined(remValue[0].variablevalue) && remValue[0].variablevalue !== '' ? remValue : null;
                var fromJsonValue = remValue === null ? vm.icbConfig.data : angular.fromJson(remValue[0].variablevalue);

                console.log('remValue');
                console.dir(fromJsonValue);

                $q.all(promises).then(function (response) {
                    var icbConfigPopup = modalDynamicViewFactory.$create({
                        //url: '',
                        data: [
                            {
                                name: 'stockplace',
                                info: {
                                    label: 'stockplace',
                                    placeholder: '',
                                    type: 'select',
                                    translate: false,
                                },
                                data: {
                                    field: fromJsonValue !== null && angular.isDefined(fromJsonValue['stockplace_id']) ? fromJsonValue['stockplace_id'] : '',
                                    list: response[0],
                                    id: 'stockplace_id',
                                    name: 'stockplace_name'
                                },
                                disabled: function () { return false; }
                            },
                            {
                                name: 'datefomtom',
                                info: {
                                    label: 'date_fom_tom',
                                    placeholder: '',
                                    type: 'date',
                                    translate: false,
                                },
                                data: {
                                    date_fom: fromJsonValue !== null && angular.isDefined(fromJsonValue['from_date']) ? fromJsonValue['from_date'] : '2022-01-01',
                                    date_tom: fromJsonValue !== null && angular.isDefined(fromJsonValue['to_date']) ? fromJsonValue['to_date'] : '2022-01-31',
                                    bindex: '3'
                                },
                                disabled: function () { return false; }
                            },
                            {
                                name: 'customergroup',
                                info: {
                                    label: 'custgrp',
                                    placeholder: '',
                                    type: 'select',
                                    translate: false,
                                },
                                data: {
                                    field: fromJsonValue !== null && angular.isDefined(fromJsonValue['cust_grp_id']) ? fromJsonValue['cust_grp_id'] : '',
                                    list: response[1],
                                    id: 'custgrp_id',
                                    name: 'custgrp_name'
                                },
                                disabled: function () { return false; }
                            },
                            {
                                name: 'coop',
                                info: {
                                    label: 'coop',
                                    placeholder: '',
                                    type: 'select',
                                    translate: false,
                                },
                                data: {
                                    field: fromJsonValue !== null && angular.isDefined(fromJsonValue['cust_coop_id']) ? fromJsonValue['cust_coop_id'] : '',
                                    list: response[2],
                                    id: 'coop_id',
                                    name: 'coop_name'
                                },
                                disabled: function () { return false; }
                            },
                            {
                                name: 'custno',
                                info: {
                                    label: 'write_custno_label',
                                    placeholder: '',
                                    type: 'input',
                                    translate: false,
                                },
                                data: {
                                    field: fromJsonValue !== null && angular.isDefined(fromJsonValue['cust_no']) ? fromJsonValue['cust_no'] : '',
                                },
                                disabled: function () { return false; }
                            },
                            {
                                name: 'prodgrp',
                                info: {
                                    label: 'prodgrp_label',
                                    placeholder: '',
                                    type: 'list',
                                    translate: false,
                                },
                                data: {
                                    field: fromJsonValue !== null && angular.isDefined(fromJsonValue['prod_grp_id']) ? fromJsonValue['prod_grp_id'] : '',
                                    list: response[3],
                                    id: 'item_id',
                                    name: 'item_name',
                                    filter: '',
                                    allSelected: false
                                },
                                disabled: function () { return false; }
                            }
                        ]
                    });

                    icbConfigPopup.show().then(function (config) {
                        return deferred.resolve(config);
                    });
                });

                return deferred.promise;
            };

            var getSelectedItemsAsString = function (list) {
                var listStr = '';

                angular.forEach(list, function (item) {
                    if (angular.isDefined(item) && angular.isDefined(item.is_selected) && item.is_selected === true) {
                        if (listStr.length > 0) listStr += ',';

                        listStr += "'" + item.item_id + "'";
                    }
                });

                return listStr;
            };

            // #endregion UTILITY FUNCTIONS

            // #region TOOLBAR BUTTONFUNC

            var printPreview = function () {
                console.log('printPreview');

                stateService.go('selectreport', {
                    webpage_name: stateService.getCurrentName(),
                    argtype: '',
                    argvalue: ''
                });
            };

            var callConfigPopup = function (rebind, remValue) {
                remValue = angular.isDefined(remValue) ? remValue : null;
                initConfigPopup(remValue).then(function (config) {

                    vm.icbConfig.data = {
                        stockplace_id: config[0].data.field,
                        from_date: config[1].data.date_fom,
                        to_date: config[1].data.date_tom,
                        cust_grp_id: config[2].data.field,
                        cust_coop_id: config[3].data.field,
                        cust_no: config[4].data.field,
                        prod_grp_id: getSelectedItemsAsString(config[5].data.list)
                    };

                    vm.grid.dataTask.loadData.parameters = vm.icbConfig.data;

                    rememberFunc();

                    vm.gridReady = true;

                    if (rebind === true) vm.grid.gridfunc.rebind();
                });
            };

            // #endregion TOOLBAR BUTTONFUNC

            // #region ROW BUTTONFUNC

            //var goToShipment = function (data) {
            //    console.log('Test run successfully');
            //    console.dir(data);

            //    goTo('shipment', data.shipmentcontainer_keyno);
            //};

            //var goToShipmentDisability = function (data) {
            //    if (angular.isUndefined(data) || angular.isUndefined(data.shipmentcontainer_keyno) || data.shipmentcontainer_keyno === null || data.shipmentcontainer_keyno === '') return true;

            //    return false;
            //};

            //var goToPoh = function (data) {
            //    console.log('Test run successfully');
            //    console.dir(data);

            //    goTo('poh', data.poh_keyno);
            //};

            //var goToPohDisability = function (data) {
            //    if (angular.isUndefined(data) || angular.isUndefined(data.poh_keyno) || data.poh_keyno === null || data.poh_keyno === '') return true;

            //    return false;
            //};

            // #endregion ROW BUTTONFUNC

            // #region LOAD PROCEDURE CALLS

            angular.element(document).ready(function () {
                invoiceCustomerBonusService.getRemember(null, vm.icbConfig.rememberId).then(function (value) {
                    //console.log('value');
                    //console.dir(value);
                    callConfigPopup(false, value);

                    //if (angular.isDefined(value) && angular.isDefined(value[0]) && angular.isDefined(value[0].variablevalue)) {
                    //    if (value[0].variablevalue !== '') vm.seasonyears.field = angular.fromJson(value[0].variablevalue);
                    //}

                    //invoiceCustomerBonusService.getSeasonYearList().then(function (data) {
                    //    //console.dir(data);
                    //    angular.copy(data, vm.seasonyears.list);
                    //    if (vm.seasonyears.list.length > 0 && vm.seasonyears.field === '') vm.seasonyears.field = vm.seasonyears.list[0].seasonyear_id;

                    //    if (vm.seasonyears.field.length > 0) vm.grid.dataTask.loadData.parameters = { seasonyear_id: vm.seasonyears.field };

                    //    vm.gridReady = true;
                    //});
                });
            });

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE PROCEDURE FUNCTIONS

            var rememberFunc = function (parm) {
                invoiceCustomerBonusService.remember(null, vm.icbConfig.rememberId, vm.icbConfig.data);
            };

            // #endregion REMEMBER VALUE PROCEDURE FUNCTIONS
            
        }]
    });
})();
